/**
 * Standalone home for the full sync-run table, moved off the dashboard by
 * assets/handoffs/design_handoff_integrations_widget (replaced there by
 * DashboardPage/CalendarSourcesWidget). Reached via that widget's
 * "View all syncs →" link. The table itself (DashboardPage/Imports) is
 * unchanged — only where it renders moved.
 */
import React, { useEffect } from "react";
import PageTemplate from "./../templates/PageTemplate";
import Imports from "./DashboardPage/Imports";
import { useImportsStore } from "../../../hooks/redux/imports";
import { useIntegrationsStore } from "../../../hooks/redux/integrations";

const SyncHistoryPage = () => {
  const { fetchImports, imports } = useImportsStore();
  const { integrations, fetchIntegrations } = useIntegrationsStore();

  // Imports rows only carry integration_uuid; the "Integration" column
  // resolves it against this collection, so it must be fetched here too —
  // don't rely on it having been loaded by a previous page (e.g. reaching
  // this page via a direct link, not the dashboard widget).
  useEffect(() => {
    fetchIntegrations();
  }, []);

  return (
    <PageTemplate sidebarId="integrations" title={"Sync history"} icon={"sync"}>
      <Imports
        imports={imports}
        integrations={integrations.collection}
        fetchImports={fetchImports}
      />
    </PageTemplate>
  );
};

export default SyncHistoryPage;
